<template>
  <div class="form-control">
    <div
      class="form-control__select"
      :class="{
        'form-control__select--placeholder': !element,
        'form-control__select--disabled': disabled,
        'form-control__select--selected': element,
      }"
      @click="visible = !visible"
    >
      <label
        class="form-control__select_label"
        :class="{ 'form-control__select_label--selected': element }"
      >
        {{ placeholder }}
        <span class="form-control__select_label_required" v-if="required">*</span>
      </label>
      <span class="text">
        {{ element }}
      </span>
      <span class="icon" :class="{ 'icon--open': !disabled ? visible : false }">
        <IconArrowTop class="icon-arrow" width="13" height="10" color="#fff"></IconArrowTop>
      </span>
    </div>
    <div
      class="form-control__items"
      :class="{ 'form-control__items--visible': !disabled ? visible : false }"
    >
      <div class="form-control__items_body">
        <ul class="list">
          <li v-for="i in items" :key="i.id">
            <a
              class="list__item"
              :class="{
                'list__item--active': element === i.title,
              }"
              @click.prevent="
                $emit('input', {
                  id: i.id,
                  title: i.title,
                });
                visible = false;
              "
              ><span :class="`list__item--status_${i.title}`"></span>{{ i.title }}</a
            >
          </li>
        </ul>
      </div>
    </div>
    <p class="form-control__error">{{ validateError }}</p>
  </div>
</template>
<script>
import IconArrowTop from "@/components/icons/IconArrowTop.vue";
export default {
  props: {
    items: { type: Array },
    selected: { type: [String, Number], required: false },
    placeholder: { type: String, default: "" },
    label: { type: String },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    validateError: { type: String, default: "" },
  },
  components: { IconArrowTop },
  data() {
    return {
      visible: false,
      element: "",
    };
  },
  created() {
    this.takeSelect();
  },
  watch: {
    selected(val) {
      if (val === null) this.element = "";
      else this.takeSelect();
    },
  },
  methods: {
    takeSelect() {
      for (let el of this.items) {
        if (this.selected == el.id) {
          this.element = el.title;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  position: relative;
  margin-top: 10px;
  cursor: pointer;
  &__select {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 4rem;
    color: $white;
    border-bottom: 1px solid $grey;
    @include type($ff: $fontFrutiger, $fs: 1.4rem, $fw: 400, $lh: 1.2);
    transition: all 0.3s ease;
    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
      height: 4rem;
      font-size: 14px;
    }
    &--selected {
      border-bottom: 1px solid $white;
    }
    &--disabled {
      opacity: 0.6;
      cursor: default;
    }
    &:hover {
      .icon {
        background-color: $white;
        &-arrow::v-deep g {
          fill: $black;
        }
      }
    }
    &_label {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      @include type($ff: $fontFrutiger, $fs: 1.6rem, $fw: 400, $lh: 1.2, $ls: -0.27px);
      transition: all 0.1s ease;
      color: rgba($color: $white, $alpha: 0.7);
      pointer-events: none;
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
      &--selected {
        display: none;
      }
      &_required {
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        color: $error;
        margin-left: 4px;
        @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
          font-size: 14px;
        }
      }
    }
    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 5px;
      color: $white;
      @include type($ff: $fontFrutiger, $fs: 1.6rem, $fw: 400, $lh: 1.2, $ls: -0.27px);
      @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
        font-size: 14px;
      }
    }
  }
  &--invalid {
    .form-control__select {
      border: 1px solid $error;
      color: $error;
    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.4px solid $white;
    border-radius: 5px;
    width: 2.8rem;
    height: 2.8rem;
    transition: all 0.3s ease-in-out;
    &-arrow {
      transform: rotate(90deg);
      transition: all 0.3s ease-in-out;
    }
    &--open {
      background-color: $white;
      .icon-arrow {
        transform: rotate(180deg);
        &::v-deep g {
          fill: $black;
        }
      }
    }

    @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
    }
  }
  &__items {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: -10px;
    transform: translate(0, 100%);
    z-index: 8;
    padding: 10px 15px;
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    background-color: $lightBlack;
    border: 1px solid $dark2Grey;
    border-radius: 14px;
    &--visible {
      visibility: visible;
      opacity: 1;
      max-height: 500px;
    }
    &_body {
      padding: 5px 0;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba($color: $black, $alpha: 0.25);
      .list {
        overflow: hidden;
        overflow-y: auto;
        max-height: 280px;
        &__item {
          display: block;
          @include type($ff: $fontFrutiger, $fs: 1.6rem, $fw: 400, $lh: 1.2, $ls: -0.27px);
          color: $white;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 5px;
          &:hover,
          &--active {
            color: $blue;
          }
          @media (max-height: 499px) and (max-width: 899px), (max-width: $sm) {
          }
          a {
            color: inherit;
            font-size: inherit;
            font-weight: inherit;
          }
        }
      }
    }
  }
}
</style>